function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, ref, computed } from "vue";
import { definePropType } from "@types-vue/props";
// import { isValidateName } from '@com/utils/number'
import MagicString from "magic-string";
import { diffChars } from "diff";
export default defineComponent({
    name: "PushName",
    props: {
        value: String,
        // 是否批量
        batch: Boolean,
        options: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        disabled: Boolean
    },
    // components: { BatchRenameDialog },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleInput = function handleInput(value) {
            var _value;
            var oldValue = (_value = inputValue.value) !== null && _value !== void 0 ? _value : "";
            if (props.batch) {
                // {abc} | {ab} | {a | a}
                // 1. 不变
                // 2. 少中间的字符
                // 3. 多中间的字符
                // 4. 少左边的{
                // 5. 少右边的}
                // 综合以上情况，只要满足其中一种情况，则对应的selected为false
                var diff = diffChars(oldValue, value);
                // 有花阔号 或者 中间的字符少了
                var removedInfo = getRemoveInfo(diff, oldValue);
                // 检查是否包含预设的文案，仅限batch=true
                if (removedInfo && removedInfo.start > -1 && removedInfo.end > -1) {
                    setTimeout(function() {
                        var _$ref;
                        var input = (_$ref = inputRef.value) === null || _$ref === void 0 ? void 0 : _$ref.$refs.input;
                        input === null || input === void 0 ? void 0 : input.setSelectionRange(removedInfo.start, removedInfo.start);
                    });
                    emit("input", wrapperAppendString(new MagicString(oldValue).update(removedInfo.start, Math.min(removedInfo.end, oldValue.length), "").toString()));
                    return;
                }
            }
            emit("input", wrapperAppendString(value));
        };
        var wrapperAppendString = function wrapperAppendString(value) {
            return value ? "".concat(value, "_").concat(append.value) : append.value;
        };
        var getRemoveInfo = function getRemoveInfo(diff, source) {
            var index = 0;
            // 通过限制操作，只取第一个的删除操作
            console.log("aaa diff", diff);
            for(var i = 0; i < diff.length; i++){
                var part = diff[i];
                if (part.removed) {
                    return getBlockPosition(source, part.value, index);
                }
                index += part.value.length;
            }
            return null;
        };
        var needDeleteBeforeUnderline = // 检查是否需要删除指定范围前面的下划线
        function needDeleteBeforeUnderline(source, startIndex, endIndex) {
            if (startIndex === -1 || endIndex === -1) {
                return false;
            }
            var willBeDeletedChar = source.substring(startIndex, endIndex);
            var beforeChar = source.charAt(startIndex - 1);
            if (willBeDeletedChar.startsWith("{") && willBeDeletedChar.includes("}") && beforeChar === "_") {
                return true;
            }
            return false;
        };
        var toggleTag = function toggleTag(tag) {
            var selected = isInclude(tag);
            if (!selected) {
                addString(tag);
            } else {
                // 移除
                removeString(tag);
            }
        };
        var addString = function addString(tag) {
            var appendString = props.batch ? "{".concat(tag.label, "}") : tag.name;
            var oldValue = inputValue.value ? inputValue.value + "_" : "";
            handleInput("".concat(oldValue).concat(appendString));
        };
        var replaceString = function replaceString(source, content) {
            var index = source.indexOf(content);
            if (index > -1) {
                return (source.substring(0, index) + source.substring(index + content.length)).replace(/^_+/g, "");
            }
            return source;
        };
        var getContent = function getContent(tag) {
            return props.batch ? "{".concat(tag.label, "}") : "".concat(tag.name);
        };
        var removeString = function removeString(tag) {
            var content = getContent(tag);
            var _value;
            var oldValue = (_value = inputValue.value) !== null && _value !== void 0 ? _value : "";
            var newValue = oldValue;
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (newValue.includes("_".concat(content))) {
                    newValue = replaceString(newValue, "_".concat(content));
                    continue;
                }
                if (newValue.includes(content)) {
                    newValue = replaceString(newValue, content);
                    continue;
                }
                break;
            }
            // handleInput(newValue)
            // 直接触发更新，跳过 diff 算法
            emit("input", wrapperAppendString(newValue));
        };
        var isInclude = function isInclude(tag) {
            var content = getContent(tag);
            var _value;
            return ((_value = inputValue.value) !== null && _value !== void 0 ? _value : "").includes(content);
        };
        var inputRef = ref();
        var displayOptions = computed(function() {
            var sorted = {};
            props.options.filter(function(option) {
                return !option.disabled;
            }).forEach(function(option, index) {
                var _value;
                var source = (_value = props.value) !== null && _value !== void 0 ? _value : "";
                var content = getContent(option);
                var i = source.indexOf(content);
                sorted[i === -1 ? source.length + index : i] = option;
            });
            return _toConsumableArray(Object.keys(sorted).sort(function(a, b) {
                return a - b;
            }).map(function(i) {
                return sorted[i];
            })).concat(_toConsumableArray(props.options.filter(function(option) {
                return option.disabled;
            })));
        });
        var append = computed(function() {
            return displayOptions.value.filter(function(option) {
                return option.disabled;
            }).map(function(option) {
                return getContent(option);
            }).join("_");
        });
        var inputValue = computed(function() {
            var _$ref, _$ref1;
            var s = "_".concat(append.value);
            if ((_$ref = props.value) === null || _$ref === void 0 ? void 0 : _$ref.endsWith(s)) {
                return props.value.slice(0, props.value.length - s.length);
            } else if ((_$ref1 = props.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.endsWith(append.value)) {
                return props.value.slice(0, props.value.length - append.value.length);
            }
            return props.value;
        });
        // 获取删除信息，主要解决blocked删除，主要存在删除字符 {anythind char} 中的任意字符，就要整体删除的问题，
        // 所以返回的所以范围字符一定是Blocked，即：{anythind char}
        // 但这层并不判断是否是batch case，是否关联 tag.label值， 这取决于下层调用如何去应用
        function getBlockPosition(source, removedChar, removedCharIndex) {
            var start = -1;
            var end = -1;
            var index = removedCharIndex;
            var hasBlockStart = removedChar.indexOf("{") > -1;
            var hasBlockEnd = removedChar.lastIndexOf("}") > -1;
            // 结束位置和开始位置相比，开始位置在自负的左侧，结束位置在字符的右侧，故+1
            var endMoveRightColPosition = 1;
            if (hasBlockStart && hasBlockEnd) {
                start = index;
                end = index + removedChar.length;
                var blockStartIndex = removedChar.lastIndexOf("{");
                var blockEndIndex = removedChar.indexOf("}");
                if (blockEndIndex < blockStartIndex) {
                    // 拆开判断 3}_{项
                    // 也能处理中间n个Blocked的case，例如： 3}_{anythind char}_{anythind char}_{anythind char}_{项
                    var leftBlockChar = removedChar.substring(0, blockEndIndex + 1);
                    var leftPosition = getBlockPosition(source, leftBlockChar, removedCharIndex);
                    var restBlockChar = removedChar.substring(blockEndIndex + 1);
                    var restPosition = getBlockPosition(source, restBlockChar, removedCharIndex + leftBlockChar.length);
                    start = Math.min(leftPosition.start === -1 ? Infinity : leftPosition.start, restPosition.start === -1 ? Infinity : restPosition.start, start);
                    end = Math.max(leftPosition.end === -1 ? -Infinity : leftPosition.end, restPosition.end === -1 ? -Infinity : restPosition.end, end);
                }
            } else if (hasBlockStart) {
                start = index;
                var blockEndIndex1 = source.indexOf("}", start);
                var nextBlockStartIndex = source.indexOf("{", index + removedChar.length + 1);
                // {项目ID}{ => {项目ID}
                end = blockEndIndex1 === -1 ? index + removedChar.length : blockEndIndex1 + endMoveRightColPosition;
                if (blockEndIndex1 > -1 && nextBlockStartIndex > -1 && nextBlockStartIndex > blockEndIndex1) {
                    end = blockEndIndex1 + endMoveRightColPosition;
                } else if (blockEndIndex1 > -1 && nextBlockStartIndex === -1) {
                    end = blockEndIndex1 + endMoveRightColPosition;
                } else {
                    end = index + removedChar.length;
                }
            } else if (hasBlockEnd) {
                end = index + removedChar.length;
                // {项目ID}} => {项目ID}
                // } =>
                var blockStartIndex1 = source.lastIndexOf("{", end);
                var preBlockEndIndex = source.lastIndexOf("}", index - 1);
                // 如果前面有blockStart，并且要blockStart是当前blockEnd的对称Block，blockStartIndex才是真正的所以值，否则 index
                // 兼容删除的block不是对称的case
                if (blockStartIndex1 > -1 && preBlockEndIndex > -1 && blockStartIndex1 > preBlockEndIndex) {
                    start = blockStartIndex1;
                } else if (blockStartIndex1 > -1 && preBlockEndIndex === -1) {
                    start = blockStartIndex1;
                } else {
                    start = index;
                }
            } else {
                // 无花括号
                var leftBlockStart = source.lastIndexOf("{", index);
                var leftBlockEnd = source.lastIndexOf("}", index);
                start = leftBlockStart > leftBlockEnd || leftBlockStart !== -1 && leftBlockEnd === -1 ? leftBlockStart : -1;
                var rightBlockStart = source.indexOf("{", index);
                var rightBlockEnd = source.indexOf("}", index);
                end = rightBlockStart > rightBlockEnd || rightBlockEnd !== -1 && rightBlockStart === -1 ? rightBlockEnd + endMoveRightColPosition : -1;
            }
            if (start === -1 || end === -1) {
                return {
                    start: -1,
                    end: -1
                };
            }
            if (needDeleteBeforeUnderline(source, start, end)) {
                start = start - 1;
            }
            // 检查是否包含预设的文案，仅限batch=true
            if (props.batch) {
                var willBeDeletedChar = source.substring(start, end);
                // console.log('aaa willBeDeletedChar', willBeDeletedChar)
                var isBlockedDeleted = props.options.some(function(option) {
                    var content = getContent(option);
                    return willBeDeletedChar.includes(content);
                });
                if (!isBlockedDeleted) {
                    return {
                        start: index,
                        end: index + removedChar.length
                    };
                }
            }
            return {
                start: start,
                end: end
            };
        }
        return {
            inputValue: inputValue,
            displayOptions: displayOptions,
            inputRef: inputRef,
            handleInput: handleInput,
            toggleTag: toggleTag,
            isInclude: isInclude,
            append: append
        };
    }
});
